<script setup lang="ts">
interface Props {
  hideLayers: Boolean;
}

defineProps<Props>();
</script>
<template>
  <div
    :class="[
      'card-underlay',
      { 'card-underlay--hide': hideLayers },
      'card-underlay--1',
    ]"
  ></div>
  <div
    :class="[
      'card-underlay',
      { 'card-underlay--hide': hideLayers },
      'card-underlay--0',
    ]"
  ></div>
</template>

<style scoped lang="postcss">
.card-underlay {
  @apply absolute rounded-lg w-[99%] left-1/2 -translate-x-1/2 h-full scale-[0.98] -top-[.59rem] transition-all duration-500;

  &--hide {
    @apply opacity-0 translate-y-4;
  }

  &--0::before,
  &--1::before {
    @apply w-[101%] bg-white absolute left-1/2 -translate-x-1/2 rounded-lg transition-all;
  }

  &--0 {
    @apply bg-neutral-500 -z-[5];
  }

  &--0::before {
    content: '';

    @apply h-full -z-[5] rounded-lg top-[.15rem];
  }

  &--1 {
    @apply -top-[1.16rem] bg-neutral-400 scale-[0.95] -z-[20];
  }

  &--1::before {
    content: '';

    @apply h-[101%] -z-[15] top-[.1rem];
  }
}
</style>
